import * as React from 'react';
import * as style from './style.css';

export const PromoOfferControls = ({ children }: React.PropsWithChildren) => {
  return <div className={style['controls']}>{children}</div>;
};
